// extracted by mini-css-extract-plugin
export var fullWidthButton = "_h4-0";